import React from 'react';
import PropTypes from 'prop-types';

import InfoToolTip from '../../InfoToolTip';
import { useTranslation } from 'react-i18next';

function InvoiceWarning({ hasInvoice }) {
  const { t } = useTranslation();
  if (!hasInvoice) {
    return null;
  }

  return (
    <div>
      <div
        className="label label-warning"
      >
        <i className="fa fa-warning" />
        {t("Fakturerat")}
      </div>
      <InfoToolTip title="Utbetalning">
        {t("invoiceForPeriodAlreadyCreated")}
      </InfoToolTip>
    </div>
  );
}

InvoiceWarning.propTypes = {
  hasInvoice: PropTypes.bool.isRequired,
};

export default InvoiceWarning;
